import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'bl-fornecimento-direto-cell',
    template: `
    <div class="flex justify-content-between">
      <div class="overflow-hidden">{{ displayValue }}</div>
      @if (showButton) {
        <button
          pButton
          type="button"
          icon="pi pi-list"
          class="p-button-sm p-button-text p-0 flex-shrink-0"
          style="vertical-align: baseline"
          pTooltip="Detalhes do lançamento"
          (click)="onButtonClick()"
        ></button>
      }
    </div>
    `,
    standalone: false
})
export class FornecimentoDiretoActionCellRenderer implements ICellRendererAngularComp {
  params: ICellRendererParams;
  value: string;
  displayValue: string;
  showButton: boolean;

  constructor() {}

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.updateValue(params);
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams) {
    this.updateValue(params);
    return true;
  }

  updateValue(params: ICellRendererParams) {
    this.params = params;

    this.value = params.value;
    this.displayValue = params.valueFormatted ?? params.value;

    this.showButton = !params.node.rowPinned && !params.node.footer;
  }

  onButtonClick() {
    // console.log('[FornecimentoDiretoActionCellRenderer] onButtonClick', this.params.data);
    const item = this.params.data;
    this.params.context.parentComponent.openDialogForFornecimentoDireto(item);
  }
}
